import { environment } from '../../environments/environment';

const isEnabled = (): boolean => !!environment.enableConsoleLogs;

type LogMethod = 'log' | 'debug' | 'info' | 'warn' | 'error' | 'trace';

const write = (method: LogMethod, ...args: unknown[]): void => {
  if (method === 'error' || isEnabled()) {
    console[method](...args);
  }
};

export const logger = {
  log: (...args: unknown[]): void => write('log', ...args),
  debug: (...args: unknown[]): void => write('debug', ...args),
  info: (...args: unknown[]): void => write('info', ...args),
  warn: (...args: unknown[]): void => write('warn', ...args),
  error: (...args: unknown[]): void => write('error', ...args),
  trace: (...args: unknown[]): void => write('trace', ...args),
};
